/* ============================================================
   RISCH SHOES — PROZESS + STANDORTE (Final) — JavaScript
   In Shopify: Online Shop → Themes → Code bearbeiten
   → assets/risch-prozess-standorte-final.js (neue Datei)
   → In layout/theme.liquid vor </body> einbinden:
     <script src="https://assets.calendly.com/assets/external/widget.js" async></script>
     <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet">
     <script src="{{ 'risch-prozess-standorte-final.js' | asset_url }}" defer></script>
   ============================================================ */

/* ── CALENDLY POPUP ────────────────────────────────────────
   Wird inline auf jedem Button aufgerufen:
   onclick="rischCalendly('https://calendly.com/dein-link')"
   
   Alternativ: direkter onclick auf dem <a>-Tag wie im Liquid.
   Diese Funktion ist ein optionaler Helper.
   ---------------------------------------------------------- */
function rischCalendly(url) {
  if (typeof Calendly !== 'undefined') {
    Calendly.initPopupWidget({ url: url });
  }
  return false;
}

/* ── SCROLL FADE-IN ────────────────────────────────────────
   Sektionen mit Klasse .rs-fade werden beim Scrollen
   sanft eingeblendet. Optional — Klasse .rs-fade auf
   .rs-block Elemente setzen um es zu aktivieren.
   ---------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var elements = document.querySelectorAll('.rs-fade');
  if (!elements.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('rs-fade--in');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  elements.forEach(function (el) { observer.observe(el); });
});